import { render, staticRenderFns } from "./PartialForm.vue?vue&type=template&id=bcffc6b0&"
import script from "./PartialForm.vue?vue&type=script&lang=ts&"
export * from "./PartialForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports